import React from "react";
import { 
    Button,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Col, 
    FormGroup, 
    Input, 
    Label, 
    Row,
} from "reactstrap";

// Requests
import { 
    getProjectRequest, 
    createProjectRequest, 
    updateProjectRequest 
} from "api/project";
// Helpers
import { calculateVATByPrice } from "helpers/pricing";
import { calculateTCP } from "helpers/pricing";
// Components
import CurrencyInput from "components/CurrencyInput/CurrencyInput";
// Contexts
import ProjectContext from "contexts/ProjectContext";
class ProjectForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            project: {},
            error: null,
			saving: false,
            generateUnit: false
        }
    }

    static contextType = ProjectContext;

    async componentDidMount() {
		const params = new URLSearchParams(this.props.location.search);
		const id = params.get('id');

        if (id) {
			try {
				const project = await getProjectRequest(id);
				this.setState({ project })
			} catch(err) {
				this.setState({
					error: err.message || 'There was an error fetching project'
				});
			}
        }
    }

    goTo = path => this.props.history.push(path);

    onChangeField = (e) => {
		const { target } = e;
		let { name, value } = target;
		this.setState(prevState => ({
			project: {
				...prevState.project,
				[name]: value,
			},
		}));
	}

    onGenerateNewUnits = (e) => {
        const { target } = e;
        const { name, checked } = target;

        this.setState(prevState => ({
            project: {
                ...prevState.project,
                [name]: checked,
                units: []
            },
        }));
    }

    addModels = () => {
		const { models=[] } = this.state.project;
		this.setState((prevState) => ({
			project: {
				...prevState.project,
				models: [
					...models,
					{
						name: '',
						price: 0,
						vat: 0,
						tcp: 0
					}
				]
			}
		}))
	}

    addUnits = (e) => {
        const { units=[] } = this.state.project;
		this.setState((prevState) => ({
			project: {
				...prevState.project,
				units: [
					...units,
					{
						block_number: 0,
                        first_lot_number: 0,
                        last_lot_number: 0
					}
				]
			}
		}))
    }

    handleModelChange = (event) => {
		const { name, value, index } = event.target;
		const { models } = this.state.project;
		const updatedModel = [...models];

        if (name === 'price') {
            let vat = calculateVATByPrice(value)
            let tcp = calculateTCP(value, vat)

            updatedModel[index] = {
                ...updatedModel[index],
                [name]: value,
                vat,
                tcp
            }
        } else {
            updatedModel[index] = {
                ...updatedModel[index],
                [name]: value
            }
            
        }

		this.setState((prevState) => ({
			project: {
				...prevState.project,
				models: updatedModel
			}
		}));
	}
    
    handleUnitChange = (index) => (event) => {
		const { name, value } = event.target;
		const { units } = this.state.project;
		const updatedUnit = [...units];

		updatedUnit[index] = {
			...updatedUnit[index],
			[name]: value
		}
		this.setState((prevState) => ({
            project: {
                ...prevState.project,
				units: updatedUnit
			}
		}));
	}
    
    deleteModel = (modelIndex) => () => {
		const { models=[] } = this.state.project;
		const updateModel = [...models];
		updateModel.splice(modelIndex, 1);
		this.setState((prevState) => ({
			project: {
				...prevState.project,
				models: updateModel
			}
		}));
	}

    deleteUnit = (modelIndex) => () => {
		const { units=[] } = this.state.project;
		const unitUpdate = [...units];
		unitUpdate.splice(modelIndex, 1);
		this.setState((prevState) => ({
			project: {
				...prevState.project,
				units: unitUpdate
			}
		}));
	}

    save = async () => {
		this.setState({
			saving: true
		})
        const { loadContextProjects } = this.context;
		const { project } = this.state;
		const { _id } = project;
        
		try {
	        if (_id) {
				await updateProjectRequest(project);
			} else {
				await createProjectRequest(project);
			}
			this.setState({
				saving: false
			})
            await loadContextProjects()
			this.goTo('/projects');
		} catch (err) {
			this.setState({
				error: err.message || 'There was an error saving Project',
				saving: false
			})
		}
	
	}



    render() {
        const {
			project = {},
			error = null,
			saving,
		} = this.state;
        
        const {
            _id,
            name,
            description,
            models=[],
            units=[],
            generateNewUnits,
            maxCommission,
            createdAt,
            updatedAt
        } = project || {}

        return(
            <div className="content">
                <Row>
                    <Col md="12">
                        <Card>
                            <CardHeader className="mb-5">
								<CardTitle tag="h3">
									Project
                                    <Button
                                        className="float-right"
                                        color="default"
                                        onClick={() => this.goTo('/projects')}
                                    >
                                        Back
                                    </Button>
                                </CardTitle>
                            </CardHeader>
                            <CardBody>
							    <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>Name <span className="required-start">*</span></Label>
                                            <Input
                                                type="text"
                                                name="name"
                                                value={name || ''} 
                                                onChange={this.onChangeField}
                                                placeholder="Name"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
							    <Row>
                                    <Col sm={12}>
                                        <FormGroup>
                                            <Label>Description</Label>
                                            <Input
                                                type="textarea"
                                                name="description"
                                                value={description || ''} 
                                                onChange={this.onChangeField}
                                                placeholder="Description"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
							    <Row>
                                    <Col sm={6}>
                                        <FormGroup>
                                            <Label>Max Commission (%)</Label>
                                            <Input
                                                type="number"
                                                name="maxCommission"
                                                value={maxCommission || 7.5} 
                                                onChange={this.onChangeField}
                                                placeholder="Max Commission"
                                                min="0"
                                                max="7.5"
                                                step="0.1"
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Card className="detail-card">
									<CardHeader>
										<h3>Models <i role="button" onClick={this.addModels} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
                                        <p>Include all models belonging to this project.</p>                                    </CardHeader>
                                    <CardBody>
                                        <FormGroup>
                                            {models.map((model, index) => (
                                                <Card className="p-3" key={index} style={{border: "1px solid #2b3553"}}>
                                                    <h5>Model {model.name ||`#${index + 1}`}</h5>
                                                    <Row className="my-3">
														<Col sm={5}>
                                                            <Label>Name <span className="required-start">*</span></Label>
															<Input
																type="text"
																name="name"
																placeholder="Name"
																value={model.name}
																onChange={(value) => this.handleModelChange({ target: { name: "name", value: value.target.value, index } })}
                                                                
															/>
														</Col>
														<Col sm={5}>
                                                            <Label>Price <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																name="price"
																placeholder="Price"
																price={model.price || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "price", value, index } })}
															/>
														</Col>
													</Row>
                                                    <Row className="my-3">
                                                        <Col sm={5}>
                                                            <Label>VAT <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																type="number"
																name="vat"
																placeholder="VAT"
																price={model.vat || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "vat", value, index } })}
															/>
														</Col>
														<Col sm={5}>
                                                            <Label>TCP <span className="required-start">*</span></Label>
                                                            <CurrencyInput
																type="number"
																name="tcp"
																placeholder="TCP"
																price={model.tcp || 0}
																onChange={(value) => this.handleModelChange({ target: { name: "tcp", value, index } })}
															/>
														</Col>
                                                        <Col className="d-flex align-items-center" sm={2}>
															<i onClick={this.deleteModel(index)} className="tim-icons icon-trash-simple cursor-pointer" />
														</Col>
													</Row>
                                                </Card>
                                            ))}
                                        </FormGroup>
                                    </CardBody>
                                </Card>
                                {_id && 
                                	<FormGroup>
                                        <div className="form-check">
                                            <label className="form-check-label">
                                                    <input className="form-check-input" onChange={this.onGenerateNewUnits} name="generateNewUnits" type="checkbox" checked={!!generateNewUnits} />
                                                        Create units for this project in bulk
                                                    <span className="form-check-sign">
                                                            <span className="check"></span>
                                                    </span>
                                            </label>
                                        </div>
                                    </FormGroup>
                                
                                }
                                {
                                    (!_id || generateNewUnits) && 
                                    <Card className="detail-card">
                                        <CardHeader>
                                            <h3>Blocks and Lots <i role="button" onClick={this.addUnits} className="tim-icons icon-simple-add ml-2 cursor-pointer pull-right" /></h3>
                                            <p>Include one entry for each block in project. For each block, type the number of units belonging to it.</p>
                                            <p>The system will create all necessary blocks and units according to the parameters provided.</p>
                                        </CardHeader>
                                        <CardBody>
                                            <FormGroup>
                                            {
                                                units.map((unit, index) => (
                                                    <Card className="p-3" key={index} style={{border: "1px solid #2b3553"}}>
                                                        <h5>Block</h5>
                                                        <Row className="my-3">
                                                            <Col sm={4}>
                                                                <Label>Block number <span className="required-start">*</span></Label>
                                                                <Input
                                                                    type="text"
                                                                    name="block_number"
                                                                    placeholder="Block number"
                                                                    value={unit.block_number || ''}
                                                                    onChange={this.handleUnitChange(index)}
                                                                />
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Label>First Lot number <span className="required-start">*</span></Label>
                                                                <Input
                                                                    type="number"
                                                                    name="first_lot_number"
                                                                    placeholder="First lot number"
                                                                    value={unit.first_lot_number}
                                                                    onChange={this.handleUnitChange(index)}
                                                                />
                                                            </Col>
                                                            <Col sm={3}>
                                                                <Label>Last Lot number <span className="required-start">*</span></Label>
                                                                <Input
                                                                    type="number"
                                                                    name="last_lot_number"
                                                                    placeholder="Last lot number"
                                                                    value={unit.last_lot_number}
                                                                    onChange={this.handleUnitChange(index)}
                                                                />
                                                            </Col>
                                                            <Col className="d-flex align-items-center" sm={2}>
															    <i onClick={this.deleteUnit(index)} className="tim-icons icon-trash-simple cursor-pointer" />
														    </Col>
                                                        </Row>
                                                    </Card>
                                                ))
                                            }
                                            </FormGroup>
                                        </CardBody>
                                    </Card>
                                }
                                {
                                    _id ?
                                        <Row>
                                            <Col sm={12} md={6}>
                                                <FormGroup>
                                                    <Label>Created at</Label>
                                                    <Input
                                                        type="text"
                                                        name="create_at"
                                                        value={createdAt || ''} 
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                            <Col sm={12} md={6}>
                                                <FormGroup>
                                                    <Label>Updated at <span className="required-start">*</span></Label>
                                                    <Input
                                                        type="text"
                                                        name="update_at"
                                                        value={updatedAt || ''} 
                                                        disabled
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    : null
                                }
                            </CardBody>
                            {error ? 
                                <div className="alert alert-danger m-3 mt-0">
									<span>{error}</span>
								</div> 
                            : null
							}
                            <Col>
                                <Button color="primary" block={false} className="mb-4" onClick={this.save} disabled={saving}>
                                    {saving
                                        ? "Saving..."
                                        : _id
                                            ? "Save Changes"
                                            : "Save Project"
                                    }
                                </Button>
                            </Col>
                        </Card>
                    </Col>
                </Row>
            </div>
        )
    }
}

export default ProjectForm